import { cn } from '@/utils/cn';

type ModalBaseProps = {
  className?: string;
  children: React.ReactNode;
};

const ModalBase = ({ className, children }: ModalBaseProps) => {
  return (
    <div
      className={cn(
        'fixed',
        'inset-0',
        'transition-all',
        'duration-1000',
        className,
      )}
    >
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/25"></div>

      {/* Window */}
      <div
        className={cn('absolute', 'inset-0', [
          'flex',
          'flex-row',
          'justify-center',
          'items-center',
        ])}
      >
        <div
          className={cn(
            'bg-white',
            'rounded-md',
            'text-stone-600',
            ['px-8', 'py-8', 'mx-4'],
            ['flex', 'flex-col', 'gap-4'],
          )}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

ModalBase.displayName = 'ModalBase';

export { ModalBase };
